import styled from 'styled-components';

// Background container
export const Background = styled.div<{ $backgroundImage?: string }>`
	background-image: url(${props => props.$backgroundImage});
	background-size: cover;
	background-repeat: no-repeat;
	background-position: center;
`;

export const BackgroundInner = styled.div`
	background-color: ${({ theme }) => theme.colors.background.modalView};
	padding-bottom: 30px;
`;

// Main container
export const Container = styled.div`
	background-size: cover;
	background-repeat: no-repeat;
	background-position: center;
	padding-bottom: 44px;
	padding-top: 30px;
	
	@media (max-width: 850px) {
		padding-top: 80px;
	}
`;

export const Wrapper = styled.div`
	padding: 30px;
	
	@media (max-width: 850px) {
		width: 90%;
	}
`;

// Tournament info section
export const Info = styled.div`
	position: relative;
`;

export const Title = styled.h1`
	font-size: 32px;
	font-weight: 700;
	color: ${({ theme }) => theme.colors.text.title};
	margin-bottom: 16px;
	margin: 0 0 16px 0;
	
	@media (max-width: 850px) {
		line-height: 130%;
		font-size: 24px;
	}
`;

export const ModalGame = styled.div`
	display: flex;
	margin-bottom: 16px;
`;

export const ModalGameItem = styled.div`
	align-items: center;
	background-color: ${({ theme }) => theme.colors.other.calendarBackgroundDarkPurple};
	border-radius: 100px;
	color: ${({ theme }) => theme.colors.text.alwaysWhite};
	display: flex;
	gap: 4px;
	font-size: 16px;
	font-weight: 400;
	padding: 13px 16px;
	background-color: ${({ theme }) => theme.colors.other.calendarBackgroundDarkGreen};
`;

export const Dates = styled.div`
	font-size: 20px;
	font-weight: 400;
	color: ${({ theme }) => theme.colors.text.subtitle};
	display: flex;
	gap: 25px;
	margin-bottom: 16px;
`;

export const Date = styled.div`
	color: ${({ theme }) => theme.colors.text.alwaysWhite};
	margin-top: 7px;
	font-weight: 500;
`;

export const Description = styled.div`
	color: ${({ theme }) => theme.colors.text.body};
	line-height: 130%;
	margin-bottom: 16px;
	font-size: 16px;
`;

export const RemoveEvents = styled.div`
	display: inline-flex;
	
	button {
		pointer-events: none;
	}
`;

export const ButtonDisabled = styled.div`
	border-radius: 8px;
	width: 336px;
	height: 46px;
	background: ${({ theme }) => theme.colors.control.disabled};
	cursor: pointer;
	color: ${({ theme }) => theme.colors.text.body};
	font-size: 16px;
	display: flex;
	align-items: center;
	justify-content: center;
`;

// Quest wrapper for tournaments

export const WrapperQuests = styled.div`
	color: ${({ theme }) => theme.colors.text.alwaysWhite};
	position: relative;
	padding-left: 30px;
	display: grid;
	grid-template-columns: repeat(4, 1fr);
	z-index: 3;
	font-size: 24px;
	font-weight: 600;
`; 